<template>
  <div>
    <v-dialog width="700" v-model="editFormModal" persistent>
      <v-card class="pa-5">
        <v-form ref="form">
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="detailData.deptNo"
                :items="teamItem"
                item-text="deptNm"
                item-value="deptNo"
                label="부서"
              ></v-select>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="detailData.cdDtlNo"
                :items="rankItem"
                item-text="cdDtlNm"
                item-value="cdDtlNo"
                label="직급"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="detailData.empNm"
                label="이름"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="detailData.birthDt"
                label="생년월일 (yymmdd)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field v-model="detailData.email" label="이메일">
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="detailData.mobile"
                label="휴대폰번호 (- 포함)"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="detailData.extensionTel"
                label="내선번호(0000)"
              >
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="detailData.emergencyTel"
                label="비상연락망( - 포함)"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2"
              ><v-text-field
                v-model="detailData.zipcd"
                label="우편번호"
              ></v-text-field
            ></v-col>
            <v-col cols="4"
              ><v-text-field
                v-model="detailData.addr"
                label="주소"
              ></v-text-field
            ></v-col>
            <v-col cols="4"
              ><v-text-field
                v-model="detailData.dtlAddr"
                label="상세주소"
              ></v-text-field
            ></v-col>
            <v-btn
              cols="1"
              @click="postPopClick"
              class="mt-7 elevation-0"
              outlined
              color="success"
              >주소검색
            </v-btn>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="detailData.totLeaveDay"
                label="부여휴가일"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <!-- <v-text-field
                v-model="detailData.empJoinDt"
                label="입사일"
              ></v-text-field> -->
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="valueDate"
                    label="입사일"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="date"
                  min="1950-01-01"
                  locale="ko"
                  @change="save"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
        <div class="text-center mt-15">
          <v-btn class="mr-3" @click="saveBtn" outlined color="yellow darken-3"
            >저장</v-btn
          >
          <v-btn
            class="white--text"
            @click="$emit('close')"
            depressed
            color="yellow darken-3"
            >취소</v-btn
          >
        </div>
      </v-card>
      <postPopupForm
        v-if="postPop"
        @close="postPop = false"
        @postNewData="newPostData"
      >
      </postPopupForm>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { empEdit, empDetail, empList } from "@/api/employee.js";
import postPopupForm from "@/components/common/postPopup";

export default {
  components: {
    postPopupForm,
  },
  data() {
    return {
      detailData: [],
      teamItem: [],
      rankItem: [],
      //editForm: false,
      editFormModal: true,
      postPop: false,
      // datepicker
      date: "",
      menu: false,
    };
  },
  computed: {
    valueDate() {
      return this.date ? moment(this.date).format("YYYYMMDD") : "";
    },
  },
  async created() {
    try {
      const empNo = this.$route.params.id;
      const { data } = await empDetail(empNo);

      this.detailData = data.form;
      this.date = moment(this.detailData.empJoinDt).format("YYYY-MM-DD");
    } catch (error) {
      console.log(error);
    }
    try {
      const { data } = await empList();
      this.teamItem = data.deptList;
      this.rankItem = data.empRankList;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    async saveBtn() {
      // 사원 수정 필수값
      // empNo, deptNo, empRankCd, empNm, birthDt, email, mobile, zipcd, addr, dtlAddr, empJoinDt

      this.$refs.form.validate();

      try {
        const empNo = this.detailData.empNo;

        const userData = {
          deptNo: this.detailData.deptNo, //부서코드
          empNm: this.detailData.empNm, //이름
          empRank: this.detailData.cdDtlNm, //직급
          empRankCd: this.detailData.cdDtlNo, //직급코드
          birthDt: this.detailData.birthDt,
          email: this.detailData.email,
          mobile: this.detailData.mobile,
          emergencyTel: this.detailData.emergencyTel,
          extensionTel: this.detailData.extensionTel,
          addr: this.detailData.addr,
          dtlAddr: this.detailData.dtlAddr,
          zipcd: this.detailData.zipcd,
          empJoinDt: moment(this.date).format("YYYYMMDD"),
          totLeaveDay: this.detailData.totLeaveDay,
        };
        const { data } = await empEdit(empNo, userData);

        console.log(data);

        setTimeout("location.reload()", 1000);
      } catch (error) {
        console.log(error);
      }

      // 팝업 닫기
      this.editFormModal = false;
    },
    postPopClick() {
      this.postPop = !this.postPop;
    },
    newPostData(event) {
      this.detailData.addr = event.address;
      this.detailData.zipcd = event.zonecode;
    },
    save(date) {
      this.$refs.menu.save(date);
    },
  },
};
</script>

<style></style>
